module.exports = __webpack_public_path__ + "img/answer.a045817c.png";